import { render, staticRenderFns } from "./PrimeiraObservacao.vue?vue&type=template&id=de40052e"
import script from "./PrimeiraObservacao.vue?vue&type=script&lang=js"
export * from "./PrimeiraObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports